import { render, staticRenderFns } from "./ModalEditLocationMeetingtype.vue?vue&type=template&id=588b9e60"
import script from "./ModalEditLocationMeetingtype.vue?vue&type=script&lang=js"
export * from "./ModalEditLocationMeetingtype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports